/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
const currentSeason = document
    .querySelector(".carousel-3d")
    .getAttribute("data-current-season");
const idAndLogos = document
    .querySelector(".carousel-3d")
    .getAttribute("data-logo-ids");
const matchCenterPageLink = document
    .querySelector(".carousel-3d")
    .getAttribute("data-match-center-link");
const jsonUrl =
    "https://dz8zbd8amw7pd.cloudfront.net/KCL/feeds/Comp/" +
    currentSeason +
    "/fixtures.json"; // Change to your JSON URL
// const jsonUrl = './wp-content/plugins/kcl-blocks/src/fixture-cards/fixtures-live.json';

const slidesWrap = document.getElementById("carousel-3d-slides-wrap");
function getTeamLogo(teamId) {
    const logos = JSON.parse(idAndLogos);
    const team = logos.find((item) => item.id == teamId);
    if (team) {
        return team.teamLogoRoundThumbnail;
    }
    return "No Logo Found";
}
function renderSlides(data) {
    slidesWrap.innerHTML = "";
    data.forEach((item, idx) => {
        const teamA_prefix = item.TeamANameprefix;
        const teamB_prefix = item.TeamBNameprefix;

        let teamA = {
            prefix: teamA_prefix,
            score: "",
            overs: "",
            won: false,
            logo: getTeamLogo(item.teamAid),
        };
        let teamB = {
            prefix: teamB_prefix,
            score: "",
            overs: "",
            won: false,
            logo: getTeamLogo(item.teamBid),
        };

        const matchNotStarted = (item.MatchState || "").toLowerCase() === "match not yet started";

        if (matchNotStarted) {
            // Only show overs, no runs/wickets
            teamA.overs = (item.MaxOvers1st || "20") + " Overs";
            teamB.overs = (item.MaxOvers2nd || "20") + " Overs";
            teamA.score = "";
            teamB.score = "";
        } else if (item.BattingClubName1stprefix === teamA_prefix) {
            // Map 1st and 2nd innings to the correct team
            teamA.score = `${item.Runs1st}/${item.Wickets1st}`;
            teamA.overs = `${item.Overs1st} Overs`;
            teamA.won = item.IsWon1st == "1";
            teamB.score = `${item.Runs2nd}/${item.Wickets2nd}`;
            teamB.overs = `${item.Overs2nd} Overs`;
            teamB.won = item.IsWon2nd == "1";
        } else {
            teamB.score = `${item.Runs1st}/${item.Wickets1st}`;
            teamB.overs = `${item.Overs1st} Overs`;
            teamB.won = item.IsWon1st == "1";
            teamA.score = `${item.Runs2nd}/${item.Wickets2nd}`;
            teamA.overs = `${item.Overs2nd} Overs`;
            teamA.won = item.IsWon2nd == "1";
        }
        if (
            (item.Status || "").trim() === "Live" &&
            (item.CurrentInnings == "1" || item.CurrentInnings === 1) &&
            (!teamB.score || teamB.score === "undefined/undefined" || teamB.score === "/") &&
            (!teamB.overs || teamB.overs === "undefined Overs" || teamB.overs === " Overs")
        ) {
            teamB.score = teamB.prefix;
            teamB.overs = "20 Overs";
        }
        if (
            (item.Status || "").trim() === "Live" &&
            (item.BowlingClubName1stprefix == teamA.prefix) &&
            (!teamA.score || teamA.score === "undefined/undefined" || teamA.score === "/0" || teamA.score === "/")
        ) {
            teamA.score = teamA.prefix;
            teamA.overs = "Yet to Bat";
        }
        if (
            (item.Status || "").trim() === "Live" &&
            (item.BowlingClubName1stprefix == teamB.prefix) &&
            (!teamB.score || teamB.score === "undefined/undefined" || teamB.score === "/0" || teamB.score === "/")
        ) {
            teamB.score = teamB.prefix;
            teamB.overs = "Yet to Bat";
        }
        let toss = item.Toss || "";
        let result = item.Result || "";
        let matchStatusClass = "";
        const matchNo = "Match " + (item.MatchNo || "");
        const status = (item.Status || "").trim().toLowerCase();
        let hours, minutes;
        let ampm = "";
        let formattedTime = "";
        let completedStatus = "Completed".toLowerCase();
        let liveStatus = "Live".toLowerCase();
        let upcomingStatus = "Yet To Start".toLowerCase();
        switch (status) {
            case completedStatus:
                matchStatusClass = "match-completed";
                break;
            case liveStatus:
                matchStatusClass = "match-live";
                if (item.Result != item.MatchState) {
                    result = item.MatchState || "";
                }
                break;
            case upcomingStatus:
                matchStatusClass = "match-yet-to-start";
                [hours, minutes] = (item.IST_Time || "").split(":");
                if (hours !== undefined && minutes !== undefined) {
                    hours = parseInt(hours, 10);
                    ampm = hours >= 12 ? "PM" : "AM";
                    hours = hours % 12 || 12;
                    formattedTime = `${hours}:${minutes} ${ampm}`;
                } else {
                    formattedTime = item.IST_Time || "";
                }
                toss = "Match at " + formattedTime + " on " + item.IST_Date;
                result = item.MatchState || "";
                break;
            default:
                matchStatusClass = "match-status-unknown";
        }
        const MatchID = item.MatchID || "";
        const matchCenterSectionLink = `${matchCenterPageLink}?match=${MatchID}`;

        slidesWrap.innerHTML += `<div class="carousel-3d-item carousel-item">
    <div class="sidebar_wrap ${matchStatusClass}">
        <div class="sidebar">
            <p>${item.Status || ""}</p>
        </div>
    </div>
    <div class="heading">
        <h4>${matchNo || ""}</h4>
    </div>
    <div class="main_content">
        <div class="team-container">
            <div class="team-container-item${teamA.won ? " winner" : ""}">
                <a href="${matchCenterSectionLink}">
                    <img src="${teamA.logo}" alt="${teamA.prefix}-logo" loading="lazy">
                    <div class="team-details">
                        <p>${teamA.score}</p>
                        <p>(${teamA.overs})</p>
                    </div>
                </a>
            </div>
            <div class="vs-divider">
                <span>V/S</span>
            </div>
            <div class="team-container-item${teamB.won ? " winner" : ""}">
                <a href="${matchCenterSectionLink}">
                    <img src="${teamB.logo}">
                    <div class="team-details">
                        <p>${teamB.score}</p>
                        <p>(${teamB.overs})</p>
                    </div>
                </a>
            </div>
        </div>
        <h5>${toss}</h5>
        <h6>${result}</h6>
    </div>
</div>`;
    });
}

let $ = jQuery;
let $carouselNewDrops = $('.carousel-3d-slides-wrap');

async function fetchAndRender() {
    try {
        const response = await fetch(jsonUrl, { cache: "no-store" });
        const data = await response.json();
        const jsonData = data || {};
        // Re-select after rendering

        if ($carouselNewDrops.hasClass('slick-initialized')) {
            $carouselNewDrops.slick('unslick');
            $carouselNewDrops.off('init beforeChange'); // remove old handlers
        }
        renderSlides(selectMatches(jsonData.default || jsonData));



        $carouselNewDrops.on('init', function (event, slick) {
            const currentSlide = slick.currentSlide;
            const totalSlides = slick.$slides.length;
            const cur = $(slick.$slides[currentSlide]);
            const next1 = $(slick.$slides[(currentSlide + 1) % totalSlides]);
            const next2 = $(slick.$slides[(currentSlide + 2) % totalSlides]);
            const prev1 = $(slick.$slides[(currentSlide - 1 + totalSlides) % totalSlides]);
            const prev2 = $(slick.$slides[(currentSlide - 2 + totalSlides) % totalSlides]);

            // First, clear just in case
            $(slick.$slides).removeClass(
                'fixture-slick-snext fixture-slick-snext2 fixture-slick-sprev fixture-slick-sprev2 fixture-center'
            );

            // Assign initial classes
            cur.addClass('fixture-center');
            next1.addClass('fixture-slick-snext');
            next2.addClass('fixture-slick-snext2');
            prev1.addClass('fixture-slick-sprev');
            prev2.addClass('fixture-slick-sprev2');

        });

        $carouselNewDrops.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            const totalSlides = slick.$slides.length;

            // Remove all fixture classes from ALL slides
            $(slick.$slides).removeClass(
                'fixture-slick-snext fixture-slick-snext2 fixture-slick-sprev fixture-slick-sprev2 fixture-center'
            );

            // Assign correct classes to upcoming (next) center + sides
            const cur = $(slick.$slides[nextSlide]);
            const next1 = $(slick.$slides[(nextSlide + 1) % totalSlides]);
            const next2 = $(slick.$slides[(nextSlide + 2) % totalSlides]);
            const prev1 = $(slick.$slides[(nextSlide - 1 + totalSlides) % totalSlides]);
            const prev2 = $(slick.$slides[(nextSlide - 2 + totalSlides) % totalSlides]);

            cur.addClass('fixture-center');
            next1.addClass('fixture-slick-snext');
            next2.addClass('fixture-slick-snext2');
            prev1.addClass('fixture-slick-sprev');
            prev2.addClass('fixture-slick-sprev2');
        });

        // THEN initialize slick
        $carouselNewDrops.slick({
            speed: 1000,
            arrows: false,
            dots: true,
            focusOnSelect: true,
            infinite: true,
            centerMode: true,
            slidesPerRow: 1,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerPadding: '0',
            swipe: true,
            autoplay: true,
            customPaging: function () { return ''; }
        });


    } catch (e) {
        console.error("Error fetching or rendering fixture data:", e);
        slidesWrap.innerHTML = "<p>Error loading data</p>";
    }
}

function parseISTDateTime(startdate) {
    if (!startdate) return 0;
    let dateStr = startdate.trim();

    // If AM/PM is present, parse accordingly
    const ampmMatch = dateStr.match(/(AM|PM)$/i);
    let year, month, day, hour, minute;
    if (ampmMatch) {
        // Format: MM/DD/YYYY HH:mm AM/PM
        const [mdy, hm, ampm] = dateStr.split(/[\s:]+/);
        if (!mdy || !hm || !ampm) return 0;
        [month, day, year] = mdy.split('/');
        [hour, minute] = [hm, dateStr.split(/[\s:]+/)[2]];
        hour = parseInt(hm, 10);
        minute = parseInt(minute, 10);
        if (ampm.toUpperCase() === 'PM' && hour < 12) hour += 12;
        if (ampm.toUpperCase() === 'AM' && hour === 12) hour = 0;
    } else {
        // Format: MM/DD/YYYY HH:mm or MM/DD/YYYY HH:mm:ss
        const [mdy, hms] = dateStr.split(' ');
        if (!mdy || !hms) return 0;
        [month, day, year] = mdy.split('/');
        [hour, minute] = hms.split(':');
        hour = parseInt(hour, 10);
        minute = parseInt(minute, 10);
    }
    // JS months are 0-based
    // Parse as local time (do NOT use Date.UTC)
    const dt = new Date(year, month - 1, day, hour, minute);
    return isNaN(dt.getTime()) ? 0 : dt.getTime();
}

function selectMatches(data) {
    const liveMatches = [];
    const upcomingMatches = [];
    const completedMatches = [];

    data.forEach((item) => {
        const status = (item.Status || "").trim();
        if (status === "Live") {
            liveMatches.push(item);
        } else if (status === "Yet To Start") {
            upcomingMatches.push(item);
        } else if (status === "Completed") {
            completedMatches.push(item);
        }
    });

    // Sort live and upcoming in ascending order (oldest first)
    liveMatches.sort((a, b) => parseISTDateTime(a.startdate) - parseISTDateTime(b.startdate));
    upcomingMatches.sort((a, b) => parseISTDateTime(a.startdate) - parseISTDateTime(b.startdate));
    // Sort completed in descending order (latest first)
    completedMatches.sort((a, b) => parseISTDateTime(b.startdate) - parseISTDateTime(a.startdate));

    let selected = [];

    // 1. If there is a live match, always show 1 live
    if (liveMatches.length > 0) {
        selected = [...liveMatches.slice(0, 1)];
        let needed = 6 - selected.length;

        // If there are completed, show up to 3 completed, then fill with upcoming
        if (completedMatches.length > 0) {
            let completedToShow = Math.min(completedMatches.length, 3, needed);
            selected = [...selected, ...completedMatches.slice(0, completedToShow)];
            needed = 6 - selected.length;
            selected = [...selected, ...upcomingMatches.slice(0, needed)];
        } else {
            // No completed, fill with upcoming
            selected = [...selected, ...upcomingMatches.slice(0, needed)];
        }
    } else {
        // No live matches
        if(completedMatches.length > 0 && upcomingMatches.length == 0 && liveMatches.length == 0){
            // If only completed matches exist, show up to 6 completed
            selected = [...completedMatches.slice(0, 6)];
        } else if (completedMatches.length > 0) {
            // If completed >= 3, show last 3 completed, rest upcoming
            if (completedMatches.length >= 3) {
                selected = [...completedMatches.slice(0, 3)];
                let needed = 6 - selected.length;
                selected = [...selected, ...upcomingMatches.slice(0, needed)];
            } else {
                // If completed < 3, show all completed, rest upcoming
                selected = [...completedMatches];
                let needed = 6 - selected.length;
                selected = [...selected, ...upcomingMatches.slice(0, needed)];
            }
        } else {
            // No live, no completed, show up to 6 upcoming
            selected = [...upcomingMatches.slice(0, 6)];
        }
    }

    // Always return at most 6
    return selected.slice(0, 6);
}
// Initial fetch
fetchAndRender();
// Fetch every 20 seconds
setInterval(fetchAndRender, 20000);

// Initialize the custom 3D carousel
/* eslint-enable no-console */
